var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textbox"},[_c('input',{attrs:{"type":"text","placeholder":_vm.input.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }